import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import { withRouter } from 'react-router-dom';

import AdminNavbar from "components/Navbars/AdminNavbar";
import Sidebar from "components/Sidebar/Sidebar";

import { style } from "variables/Variables.jsx";
import routes from "routes.js";

class Dashboard extends Component {

    getBrandText = path => {
        var name;
        routes.map((prop, key) => {
            if (path === prop.path) {
                name = prop.name;
            } else {
                if (path.includes(prop.name.toLowerCase())) {
                    name = prop.name;
                }
            }
            
            return null;
        });
        return name;
    };

    render() {
        const { children } = this.props

        return (
            <div className="wrapper">
            <NotificationSystem ref="notificationSystem" style={style} />
            <Sidebar {...this.props} />
            <div id="main-panel" className="main-panel" ref="mainPanel">
                <AdminNavbar
                {...this.props}
                brandText={this.getBrandText(this.props.location.pathname)}
                />
                {children}
            </div>
            </div>
        );
    }
}

export default withRouter(Dashboard);
